import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const deleteChallengeGroupRequest = createAction('deleteChallengeGroupRequest');
export const deleteChallengeGroupSuccess = createAction<number>('deleteChallengeGroupSuccess');
export const deleteChallengeGroupFailure = createAction('deleteChallengeGroupFailure');

export const deleteChallengeGroup = (id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(deleteChallengeGroupRequest());
    try {
        await api.delete(`admin/challengeGroups/${id}`);

        dispatch(deleteChallengeGroupSuccess(id));
    } catch (e: any) {
        handleApiErrors(dispatch, deleteChallengeGroupFailure, e);
    }
};
